import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const downloadDCList = createModule({
  base: 'DOWNLOAD_DC_LIST',
  apiDetails: SERVICE_ENDPOINT.DOWNLOAD_DC_LIST,
  enableNotification: true,
});

export { downloadDCList };
